import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, useEffect, useState } from 'react';
export const ClientOnly = ({ children }) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted ? _jsx(Suspense, { fallback: null, children: children }) : null;
};
